module.exports = __webpack_public_path__ + "img/china.bf7b4a44.svg";